const dictionary = {
  pages: {
    userGate: {
      'document-title': 'Bruger Konto',
      'document-desc': ''
    },

    userAccount: { 'sidebar-heading-main': 'Konto' },

    error: {
      401: {
        'document-title': 'Uberettiget',
        'document-desc': '',
        'heading-main': '401 - Uberettiget',
        'page-content': 'Du har ikke adgang til denne side uden at logge ind.'
      },

      404: {
        'document-title': 'Siden blev ikke fundet',
        'document-desc': '',
        'heading-main': '404 - Siden blev ikke fundet',
        'page-content': 'Den side du ledte efter, findes ikke.'
      },

      500: {
        'document-title': 'Der er sket en fejl',
        'document-desc': '',
        'heading-main': 'Noget gik galt',
        'page-content': 'Prøv igen senere.'
      }
    },

    home: {
      'document-title': 'Hjem',
      'document-desc': '',
      'section-top-link-badminton': 'Badminton',
      'section-top-link-golf': 'Golf',
      'section-top-link-football': 'Fodbold',
      'section-top-link-climbing': 'Klatrign',
      'section-top-link-tennis': 'Tennis',
      'section-top-link-squash': 'Squash',
      'section-top-link-allSports': 'Mere...',
      'section-middle-heading-interests': 'Interesser',
      'section-middle-heading-featured': 'Udvalgte',
      'section-middle-heading-new': 'Ny',
      'section-middle-heading-popular': 'Populær',
      'section-middle-link-allSports': 'Se alt'
    },

    sports: {
      'document-title-default': 'Tilgængelig sport',
      'document-desc-default': '',
      'heading-main-default': 'Sport',

      'document-title-sport': '{sportName}',
      'document-desc-sport': '',
      'heading-main-sport': '{sportName} muligheder',

      'document-title-search': 'Søgeresultater',
      'document-desc-search': '',
      'heading-main-search': 'Søgeresultater'
    }
  },

  views: {
    userGate: {
      login: {
        'heading-main': 'Log På',
        'menu-item-register': 'Opret konto',
        'menu-item-resetPassword': 'Glemt Kodeord',
        'menu-item-login': 'Tilbage til login',
        'field-username-label': 'Email',
        'field-username-desc': 'Din email adresse',
        'field-password-label': 'Adgangskode',
        'field-password-desc': 'Dit Kodeord',
        'field-remember-desc': 'Husk mig',
        'button-submit-login': 'Log På',
        'button-submit-resetPassword': 'Send link for at nulstille',
        'text-separator': 'eller log ind med:',
        'button-facebook': 'Facebook',
        'message-success-resetLink':
          'Vi har lige sendt et link til nulstilling af adgangskode til din email adresse',
        'message-error-mistake': 'Ugyldig e-mail eller adgangskode',
        'message-error-general': 'Kan ikke logge ind'
      },

      logout: {
        'heading-main': 'Er du sikker?',
        'text-description': 'Ønsker du at logge ud af din WannaSport-konto?',
        'button-submit': 'Log Ud',
        'button-cancel': 'Afbestille'
      },

      register: {
        'heading-main': 'Tilmeld',
        'menu-item-login': 'Jeg har allerede haft en konto',
        'field-name-label': 'Navn',
        'field-name-desc': 'Din fulde navn (ikke offentligt synlig)',
        'field-password-label': 'Adgangskode',
        'field-password-desc': 'Dit Kodeord',
        'field-passwordRepeat-label': 'bekræft kodeord',
        'field-passwordRepeat-desc': 'Gentag dit kodeord',
        'field-email-label': 'Email adresse',
        'field-email-desc': 'Din email adresse',
        'field-email-placeholder': 'eksempel@email.dk',
        'field-acceptTerms-desc': 'Jeg accepterer betingelserne',
        'field-acceptTerms-error-empty': 'Du skal acceptere vores vilkår og betingelser for at kunne fortsætte',
        'field-acceptCookies-desc': 'Jeg accepterer cookie-politikken',
        'field-acceptNews-desc': 'Jeg vil gerne modtage nyhedsbreve',
        'button-submit': 'Tilmeld',
        'message-success': 'Vellykket registrering'
      },

      changeEmail: {
        'heading-main': 'Din email opdateringsanmodning',
        'text-description': 'Du anmodede om at ændre din nuværende email adresse til',
        'status-success': 'Opdateret',
        'status-error': 'Ikke opdateret',
        'message-success': 'Din email adresse er opdateret'
      },

      confirmEmail: {
        'heading-main': 'Din email bekræftelse',
        'text-description': 'Du anmodede om at bekræfte din email adresse',
        'status-success': 'Bekræftet',
        'status-error': 'Ikke bekræftet',
        'message-success': 'Din email adresse er nu bekræftet'
      },

      resetPassword: {
        'heading-main': 'Nulstil din adgangskode',
        'field-newPassword-label': 'Nyt kodeord',
        'field-newPassword-desc': 'Vælg den næste omhyggeligt',
        'field-passwordRepeat-label': 'Kodeords bekræftelse',
        'field-passwordRepeat-desc': 'Gentag din adgangskode',
        'button-submit': 'Gem',
        'button-login': 'Gå til login-siden',
        'message-success': 'Du har nulstillet din adgangskode'
      }
    }
  },

  overlays: {
    userGate: {
      'overlay-title-login': 'Bruger indgang - log ind dialog',
      'overlay-title-logout': 'Bruger indgang - log ud dialog',
      'overlay-title-register': 'Bruger indgang - registrering dialog',
      'button-trigger-login': 'Log På',
      'button-trigger-logout': 'Log Ud',
      'button-trigger-register': 'Tilmeld',
      'button-closer': 'Annullér'
    },

    newPaymentMethod: {
      'overlay-title': 'Betalingsmetode skaber dialog',
      'button-trigger': 'Tilføj ny',
      'button-closer': 'Annullér',
      'heading-main': 'Opret ny betalingsmetode'
    },

    paymentMethodDetails: {
      'overlay-title': 'Betalingsmetode detaljer dialog',
      'button-trigger': 'Detajler...',
      'button-trigger-title': 'Se detajler...',
      'button-closer': 'Luk',
      'heading-main': 'Oplysninger om din betalingsmetode',
      'term-title': 'Betalingsmetode',
      'term-default': 'Primær',
      'term-cardholder': 'Navn',
      'term-type': 'Kort type',
      'term-expiration': 'Udløbsdato',
      'button-setDefault': 'Vælg som primær',
      'button-setDefault-title': 'Indstil denne betalingsmetode som primær',
      'button-delete': 'Slet betalingsmetode',
      'prompt-delete': 'Er du sikker på, at du vil slette denne betalingsmetode?',
      'icon-defaultPaymentMethod-title': 'Dette er primær betalingsmetoden',
      'text-loading-setDefault': 'Opdatering af primær betalingsmetode',
      'text-loading-delete': 'Sletning af din betalingsmetode',
      'message-success-setDefault': 'Primær betalingsmetode opdateres med succes',
      'message-success-delete': 'Din betalingsmetode slettes med succes'
    },

    subscriptionDetails: {
      'overlay-title': 'Abonnementsoplysninger dialog',
      'button-trigger': 'Detajler...',
      'button-closer': 'Luk',
      'tab-title': 'Detaljer om din abonnement',
      'tab-info-title': 'Abonnement info',
      'tab-transactions-title': 'Betalinger',

      infoPanel: {
        'term-reference': 'Referencenummer',
        'term-status': 'Status',
        'term-created': 'Lavet',
        'term-updated': 'Opdateret',
        'term-price': 'Pris pr måned',
        'term-period': 'Periode',
        'term-until': 'Betalt indtil',
        'term-billing': 'Næste fakturering',
        'term-discountAmount': 'Rabat',
        'term-discountExpiration': 'Udløb af rabat',
        'term-payment': 'Betalingsmetode',
        'term-termination': 'Aflyst fra',
        'text-termination-cancel': 'Er du sikker på, at du vil annullere dit abonnement?',
        'text-termination-regret':
          'Du har mulighed for at fortryde dit abonnement. Ønsker du at benytte dig af fortrydelsesretten?',
        'text-loading-changePaymentMethod': 'Ændring af betalingsmetode',
        'text-loading-terminateSubscription': 'Annullering af dit abonnement',
        'field-didRegret-description': 'Jeg ønsker at benytte mig af fortrydelsesretten',
        'button-changePaymentMethod-title': 'Skift betalingsmetode',
        'button-terminate-open': 'Annuller abonnement',
        'button-terminate-close': 'Tilbage',
        'button-terminate-cancel': 'Annuller abonnement',
        'button-terminate-regret': 'Fortryd abonnement',
        'message-success-changePaymentMethod': 'Betalingsmetode opdateret med succes',
        'message-success-cancelSubscription': 'Dit abonnement er annulleret med succes',
        'message-success-regretSubscription': 'Dit abonnement blev beklaget med succes'
      },

      transactionsPanel: {
        'heading-main': 'Betalinger',
        'text-noResults': 'Ingen betalinger hidtil',
        'column-date': 'Faktureringsdato',
        'column-price': 'Betalt'
      }
    },

    purchaseDetails: {
      'overlay-title': 'Køb detaljer dialog',
      'button-trigger': 'Detaljer...',
      'button-closer': 'Luk',
      'tab-title': 'Detaljer om dit køb',
      'tab-participants-title': 'Deltagere',
      'tab-transactions-title': 'Transaktioner',

      participantsPanel: {
        'heading-main': 'Aktivitetsdeltagere',
        'column-name': 'Deltager',
        'column-type': 'Rolle',
        'column-status': 'Status',
        'text-name-you': 'Dig',
        'text-tag-membershipped': 'Multipass',
        'text-type-undefined': 'Ingen',
        'text-type-organizer': 'Arrangør',
        'text-type-player': 'Spiller',
        'text-type-spectator': 'Tilskuer',
        'text-status-accepted': 'Accepteret',
        'text-status-pending': 'Pending',
        'text-status-rejected': 'Afvist',
        'text-status-cancelled': 'Annulleret',
        'text-noResults': 'Ingen deltagere'
      },

      transactionsPanel: {
        'heading-main': 'Købstransaktioner',
        'column-date': 'Dato',
        'column-status': 'Status',
        'column-price': 'Beløb',
        'column-paymentMethod': 'Betalingsmetode',
        'text-transactionStatus-authorized': 'Autoriseret',
        'text-transactionStatus-refund': 'Refunderet',
        'text-transactionStatus-settled': 'Gennemført',
        'text-transactionStatus-failed': 'Mislykkedes'
      }
    },

    friendInvitation: {
      'overlay-title': 'Ven invitations dialog',
      'heading-main': 'Inviter din ven',
      'field-inviteeEmail-label': 'Inviterede',
      'field-inviteeEmail-desc': 'Din vens email adresse',
      'button-trigger': 'Invitere',
      'button-submit': 'Sende indbydelse',
      'button-closer': 'Luk',
      'message-success': 'Din WannaSport indbydelse sendes til din vens email adresse ({inviteeEmail})'
    },

    emailUpdateRequest: {
      'overlay-title': 'Email ændringsanmodning dialog',
      'heading-main': 'Opdater din e-mail',
      'text-description':
        'Request your new email, then follow the instructions sent to your old email',
      'field-newEmail-label': 'Ny email adresse',
      'field-newEmail-desc': 'Din nye e-mail-adresse',
      'field-confirmEmail-label': 'Bekræftelse af email adresse',
      'field-confirmEmail-desc': 'Gentag din nye email adresse',
      'button-submit': 'Anmodning',
      'button-closer': 'Annulér',
      'message-success':
        'Vi har sendt en e-mail med yderligere instruktioner til din gamle e-mail-adresse ({oldEmailAddress})'
    },

    voucherRedeeming: {
      'overlay-title': 'Voucher indløser dialog',
      'heading-main': 'Indløs en rabatkupon',
      'field-voucherCode-label': 'Rabatkode',
      'field-voucherCode-desc': 'Rabatkode',
      'button-trigger': 'Indløs',
      'button-submit': 'Indløs',
      'button-closer': 'Luk',
      'message-success': 'Voucher indløst med succes',
      'message-error':
        'Voucher er ugyldig eller allerede brugt. For spørgsmål kontakt WannaSport Support'
    }
  },

  elements: {
    paymentMethodSelector: {
      'heading-main': 'Vælg betalingsmetode',
      'option-paymentMethod-title': 'Din betalingsmetode: {Name}',
      'button-submit': 'Gem'
    },

    newCreditCard: {
      'field-name-label': 'Kort navn',
      'field-name-desc': 'Et brugernavn til dit gemte kort',
      'field-cardholder-label': 'Kortholders navn',
      'field-cardholder-desc': 'Kortholderens fulde navn',
      'button-submit': 'Gem nyt kort',
      'loader-text': 'Kontrol af dine nye kreditkortoplysninger',
      'message-success': 'Betalingsmetode oprettes med succes'
    },

    editableArea: {
      'button-edit': 'Rediger',
      'button-edit-title': 'Rediger {ariaEditorName}',
      'button-closer': 'Annuller',
      'button-closer-title': 'Annuller ændringer',
      'button-submit': 'Gem',
      'button-submit-title': 'Gem ændringer'
    },

    customDayPicker: {
      'controller-button-month-next-title': 'Næste måned',
      'controller-button-month-prev-title': 'Forrige månedh',
      'navbar-button-month-prev-title': 'Gå til forrige måned ({monthNamePrev})',
      'navbar-button-month-next-title': 'Gå til næste måned ({monthNameNext})',
      'navbar-button-year-prev-title': 'Gå til forrige år ({yearPrev})',
      'navbar-button-year-next-title': 'Gå til næste år ({yearNext})'
    },

    customInput: {
      'passwordMeter-title': 'Dit kodeord er {strength}',
      'passwordMeter-strength-min': 'Uacceptabelt',
      'passwordMeter-strength-low': 'Meget svag',
      'passwordMeter-strength-mid': 'Svag',
      'passwordMeter-strength-high': 'God',
      'passwordMeter-strength-max': 'Stærk',
      'input-date-button-dropdown-title': 'Skift rullemenuen for datovalg',
      'input-password-button-show-title': 'Afdæk det medfølgende kodeord',
      'input-password-button-hide-title': 'Skjul den medfølgende kodeord',
      'input-select-noOptions-text': 'Ingen tilgængelige muligheder',
      'input-select-createOption-text': 'Tilføj "{userInput}"',
      'input-selectAsync-loading-text': 'Indlæser...',
      'input-selectAsync-noOptions-text': 'Ingen tilgængelige muligheder'
    },

    menu: { 'button-toggler-title': 'Skift menuen' },

    loader: { 'text-loading': 'Indlæser' },

    hugeStatusIndicator: {
      'text-pending': 'Pending',
      'text-success': 'Success',
      'text-error': 'Fejl'
    },

    siteLogo: {
      'link-homePage-title': 'Gå til startsiden',
      'image-logo-alt': 'WannaSport logo',
      'image-logotype-alt': 'WannaSport tekst'
    },

    progressMeter: {
      'progress-indicator-title': 'Fremgangsindikator',
      'list-steps-title': 'Fremskridt trin'
    }
  },

  lists: {
    systemMessages: {
      'list-title': 'Systemmeddelelser',
      'list-item-title': 'Systemmeddelelse',
      'list-item-button-dismiss-title': 'Afvis denne meddelelse',
      'text-title-success': 'Succes: {message}',
      'text-title-info': 'Information: {message}',
      'text-title-warning': 'Advarsel: {message}',
      'text-title-error': 'Der er sket en fejl: {message}'
    },

    productList: {
      'button-prev-title': 'Rul baglæns',
      'button-next-title': 'Rul frem'
    }
  },

  general: {
    messages: {
      'error-general': 'Noget gik galt',
      'error-input-empty': 'Feltet "{fieldName}" er påkrævet',
      'error-input-format': 'Formatet for feltet {fieldName} er ugyldigt',
      'error-input-email-format': 'Det angivne e-mail-format er ugyldigt',
      'error-input-password-short': 'Denne adgangskode er for kort - den skal være mindst {minLength} tegn',
      'error-input-password-weak': 'Denne adgangskode er for svag og kan let gætte af angribere',
      'error-input-password-missing-uppercase': 'Din adgangskode skal indeholde mindst 1 store bogstaver',
      'error-input-password-missing-lowercase': 'Din adgangskode skal indeholde mindst 1 små bogstaver',
      'error-input-password-missing-digit': 'Din adgangskode skal indeholde mindst 1 ciffer',
      'error-input-unmatch':
        'Indtastningsværdien af feltet {thisFieldName} stemmer ikke overens med {comparedFieldName}s',
      'error-input-long': 'Denne værdi er for lang - kun {maxLength} tegn er tilladt',
      'warning-browser-outdated':
      'Din browser eller dens version er forældet, og vi understøtter ikke længere den, derfor kan du '
      + 'muligvis bemærke uventet opførsel eller fejl. Opdater til en moderne browser for mere sikkerhed '
      + 'og bedre samlet oplevelse.',
      'prompt-leavingDirtyForm':
      'Du har allerede udfyldt nogle af de input, hvis data vil gå tabt, hvis du forlader formularen. '
      + 'Er du sikker på, at du vil fortsætte?'
    },

    dates: {
      'month-1': 'Januar',
      'month-2': 'Februar',
      'month-3': 'Marts',
      'month-4': 'April',
      'month-5': 'Maj',
      'month-6': 'Juni',
      'month-7': 'Juli',
      'month-8': 'August',
      'month-9': 'September',
      'month-10': 'Oktober',
      'month-11': 'November',
      'month-12': 'December',
      'day-1': 'Mandag',
      'day-2': 'Tirsdag',
      'day-3': 'Onsdag',
      'day-4': 'Torsdag',
      'day-5': 'Fredag',
      'day-6': 'Lørdag',
      'day-7': 'Søndag'
    },

    units: {
      'piece-short': 'stk.'
    }
  }
};

export default dictionary;